<app-view-title Title="{{ 'Intellitrailer.Rental.Component.ExtendRental.Extend' | translate : 'Extend' }}" [isSoftSplit]="true"></app-view-title>
<view-content [centered]="true">
  <div class="row">
    <div class="col-12 col-md-6">
      @if(booking.ReturnTime) {
      <p>{{ 'Intellitrailer.Booking.ExtendBookingTimePicker.CurrentTime' | translate : 'Current time return'}} : {{ this.booking.ReturnTime.toDate() | date:'MMM dd, HH:mm' | uppercase }}</p>
      }
      <app-card>
        <title-with-divider Title="{{'Intellitrailer.Booking.ExtendBookingTimePicker.ChoseNewTime' | translate : 'Choose new return time'}}"></title-with-divider>
        <mat-form-field>
          <mat-icon matPrefix (click)="setReturnDate(null, -1); $event.stopPropagation()" [ngClass]="isSameDay(this.returnDate, this.today.toDate()) ? 'unselectable' : 'selectable'">keyboard_arrow_left</mat-icon>
          <input #returnInput class="input-center" matInput [matDatepicker]="return" [(ngModel)]="returnDate" [min]="this.today.toDate()" (dateChange)="setReturnDate($event.value)" (focus)="return.open()">
          <mat-datepicker-toggle matTextSuffix [for]="return"></mat-datepicker-toggle>
          <mat-datepicker #return (closed)="returnInput.blur()"></mat-datepicker>
          <mat-icon matSuffix (click)="setReturnDate(null, 1); $event.stopPropagation()">keyboard_arrow_right</mat-icon>
        </mat-form-field>

        <timePicker #returnTime
                    [booking]="booking"
                    [minTime]="minReturn"
                    [maxTime]="maxReturn"
                    [selectedTime]="_returnTime"
                    [timeSlots]="returnSlots"
                    (selectedTimeChange)="setReturnTime($event)"
                    steps="quarter"
                    [loader]="timePickerLoading"
                    [isClosed]="returnClosed">
        </timePicker>

        @if(iniatingLoader){
        <div class="spinner-container">
          <mat-spinner class="inverted-spinner" diameter="70"></mat-spinner>
        </div>
        }
      </app-card>

      <p>{{ 'Intellitrailer.Booking.ExtendBookingTimePicker.NewTime' | translate : 'New time return'}} : {{ _returnTime.toDate() | date:'MMM dd, HH:mm' | uppercase}}</p>
      <p>
        <b>
          {{ 'Intellitrailer.Booking.ExtendBookingTimePicker.AdditionalCost' | translate : 'Additional Cost'}} :
          @if(!priceLoading) {
          {{ additionalCost | currency }}
          }
          @else { <div class="spinner-container">
            <mat-spinner diameter="20"></mat-spinner>
          </div>
          }
        </b>
      </p>
    </div>
  </div>
  @if(loader) {
  <div class="spinner-container">
    <mat-progress-spinner diameter="75" mode="indeterminate"></mat-progress-spinner>
  </div>
  }
</view-content>
<view-actions mode="white">
  <button type="button" mat-raised-button class="mw-115" [disabled]="!extendButtonEnabled || booking.ReturnTime.toDate().toISOString() == _returnTime.toDate().toISOString() || priceLoading" (click)="extend()">{{ 'Intellitrailer.Rental.Component.ExtendRental.Extend' | translate : 'Extend' }}</button>
</view-actions>
  
